import React from 'react';
import { Grid } from 'semantic-ui-react';

const Campo: React.FunctionComponent<{
    etiqueta?: string;
    valor: React.ReactNode;
    ocultar?: boolean;
}> = props => {
    const { etiqueta, valor, ocultar } = props;

    return ocultar ? null : (
        <Grid.Row style={{ marginBottom: '0.3em' }}>
            <span
                style={{
                    verticalAlign: 'top',
                    display: 'inline-block',
                    minWidth: '12em',
                }}
            >
                {etiqueta ? etiqueta + ':' : ''}
            </span>
            <span
                style={{
                    display: 'inline-block',
                    maxWidth: '20em',
                    fontWeight: 'bold',
                }}
            >
                {valor}
            </span>
        </Grid.Row>
    );
};

export default Campo;



// WEBPACK FOOTER //
// ./src/modulos/Cobranzas/componentes/FichaDeApoderado/Campo.tsx